import { useState } from 'react';

const ADMIN_PASSWORD = 'a01067404061';
const SESSION_KEY = 'ktf_admin_auth';

interface AdminLoginProps {
  onSuccess: () => void;
}

export function checkAdminAuth(): boolean {
  return sessionStorage.getItem(SESSION_KEY) === 'true';
}

export function clearAdminAuth(): void {
  sessionStorage.removeItem(SESSION_KEY);
}

export default function AdminLogin({ onSuccess }: AdminLoginProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [shake, setShake] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      sessionStorage.setItem(SESSION_KEY, 'true');
      onSuccess();
    } else {
      setError(true);
      setShake(true);
      setPassword('');
      setTimeout(() => setShake(false), 500);
    }
  };

  return (
    <div className="min-h-screen bg-[#F4F6FA] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        {/* 로고 영역 */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#1B3A6B] mx-auto mb-4">
            <i className="ri-lock-line text-white text-2xl" />
          </div>
          <h1 className="text-xl font-black text-[#1B3A6B]">관리자 페이지</h1>
          <p className="text-gray-500 text-sm mt-1">대한문신사중앙회 중구지부</p>
        </div>

        {/* 로그인 카드 */}
        <div className={`bg-white rounded-2xl border border-gray-100 p-8 transition-all ${shake ? 'animate-[shake_0.4s_ease-in-out]' : ''}`}>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                관리자 비밀번호
              </label>
              <div className="relative">
                <i className="ri-lock-password-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => { setPassword(e.target.value); setError(false); }}
                  placeholder="비밀번호를 입력하세요"
                  autoFocus
                  className={`w-full pl-9 pr-4 py-3 border rounded-lg text-sm focus:outline-none transition-colors ${
                    error
                      ? 'border-red-400 bg-red-50 focus:border-red-400'
                      : 'border-gray-200 focus:border-[#1B3A6B]'
                  }`}
                />
              </div>
              {error && (
                <p className="text-red-500 text-xs mt-2 flex items-center gap-1">
                  <i className="ri-error-warning-line" /> 비밀번호가 올바르지 않습니다.
                </p>
              )}
            </div>

            <button
              type="submit"
              className="whitespace-nowrap w-full py-3 rounded-lg bg-[#1B3A6B] text-white font-bold text-sm cursor-pointer hover:bg-[#15305a] transition-colors flex items-center justify-center gap-2"
            >
              <i className="ri-login-box-line" /> 로그인
            </button>
          </form>
        </div>

        <p className="text-center text-xs text-gray-400 mt-6">
          관리자 전용 페이지입니다. 권한이 없는 접근은 금지됩니다.
        </p>
      </div>

      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          20% { transform: translateX(-8px); }
          40% { transform: translateX(8px); }
          60% { transform: translateX(-6px); }
          80% { transform: translateX(6px); }
        }
      `}</style>
    </div>
  );
}
